<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 3C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3V4H13V3C13 2.44772 13.4477 2 14 2C14.5523 2 15 2.44772 15 3V4H16C17.1046 4 18 4.89543 18 6V7H2V6C2 4.89543 2.89543 4 4 4H5V3ZM18 8H2V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V8ZM7 14V16H5V14H7ZM7 12V10H5V12H7ZM9 14H11V16H9V14ZM11 10H9V12H11V10ZM15 14V16H13V14H15ZM15 12V10H13V12H15Z"
  />
</svg>
